import {URLConstants} from '../constants/URLConstants';
import { UserActions } from '../../redux/actions/UserActions';
import { history } from '../../components/helpers/History';

export const HttpService = {
    post,get,put
};

function post(url, payload) {
    var date = new Date()
    var offset = date.getTimezoneOffset()
    var header = { 'Content-Type': 'application/json', 
    'Access-Control-Allow-Origin': '*'};
    header['TimezoneOffset']= offset;
    if(localStorage.getItem("token")){
        header['Authorization']= 'Bearer '+localStorage.getItem("token");
    }
    const requestOptions = {
        method: 'POST',
        headers: header,
        body: JSON.stringify(payload)
    };

    return fetch(`${URLConstants.BASE_URL + url}`, requestOptions)
        .then(handleResponse)
        .then(data => {
            return data;
        });
}

function put(url, payload) {
    var date = new Date()
    var offset = date.getTimezoneOffset()
    var header = { 'Content-Type': 'application/json', 
    'Access-Control-Allow-Origin': '*'};
    header['TimezoneOffset']= offset;
    if(localStorage.getItem("token")){
        header['Authorization']= 'Bearer '+localStorage.getItem("token");
    }
    const requestOptions = {
        method: 'PUT',
        headers: header,
        body: JSON.stringify(payload)
    };

    return fetch(`${URLConstants.BASE_URL + url}`, requestOptions)
        .then(handleResponse)
        .then(data => {
            return data;
        });
}

function get(url) {
    var date = new Date()
    var offset = date.getTimezoneOffset()
    var header = { 'Content-Type': 'application/json', 
    'Access-Control-Allow-Origin': '*'};
    header['TimezoneOffset']= offset;
    if(localStorage.getItem("token")){
        header['Authorization']= 'Bearer '+localStorage.getItem("token");
    }
    const requestOptions = {
        method: 'GET',
        headers: header
    };

    return fetch(`${URLConstants.BASE_URL + url}`, requestOptions)
        .then(handleResponse)
        .then(data => {
            return data;
        });
}

function handleResponse(response) {
    return response.text().then(text => {
        const data = text && JSON.parse(text);
        if (!response.ok) {
            if (response.status === 401) {
                if(response.url && response.url.indexOf("login") >=0){
                    return Promise.reject('Email or password incorrect.');
                }else{
                    history.push("/session-expired");
                }
            }

            const error = (data && data.result && data.result.description) || response.statusText;
            return Promise.reject(error);
        }

        return data;
    });
}